// extracted by mini-css-extract-plugin
module.exports = {"switchTabWithImage":"SwitchTabModule_switchTabWithImage__KUPBb"};